import cx from 'classnames';

const defaultProps = {
  className: 'react-tabs__tab-list'
};

const TabList = (props) => {
  const { children, className, ...attributes } = props;

  return (
    <ul
      {...attributes}
      className={cx(className, `${className}-items-${children.length}`)}
      role="tablist"
    >
      {children}
    </ul>
  );
};

TabList.defaultProps = defaultProps;
TabList.tabsRole = 'TabList';
export default TabList;
